import React, { useEffect, useState } from 'react'
import { Button, Input, Form, Switch, Divider, Radio, message } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import dayjs from 'dayjs'
import { IModule, ITrame } from './util'
import { Modules } from './Modules'
import { UpOutlined } from '@ant-design/icons'

interface IProps {
  baseUrl: string
  onSave: (v: ITrame[]) => void
  trames: ITrame[]
}

export const Trame = (props: IProps) => {
  const history = useHistory()
  const { tid } = useParams<{ tid: string }>()
  const [idPreview, setIdPreview] = useState<string | undefined>(undefined)
  const [trame, setTrame] = useState<ITrame>(
    tid !== 'new'
      ? props.trames.find((t) => t.id === tid) || {
        id: uuid(),
        createdAt: dayjs().format(),
        updatedAt: dayjs().format(),
        name: '',
        modules: [],
        versionAdhoc: 2
      }
      : {
        id: uuid(),
        createdAt: dayjs().format(),
        updatedAt: dayjs().format(),
        name: '',
        modules: [],
        versionAdhoc: 2
      },
  )
  const [messageNeedSave, setMessageNeedSave] = useState<boolean>(false)

  const saveTrame = () => {
    const newTrames =
      tid === 'new' && !props.trames.find(e => e.id == trame.id)
        ? props.trames.concat(trame)
        : props.trames.map((t: ITrame) => (t.id === tid ? trame : t))
    props.onSave(newTrames)
    setMessageNeedSave(false)
  }

  useEffect(() => {
    $.ajax({
      method: 'GET',
      url: '/api/organisations/' + props.baseUrl.split('/')[2] + '/adhoc_data/get_last_v2',
      success: (data) => {
        setIdPreview(data)
      },
      error: (error) => {
        console.log(error)
      }
    })
  }, [])

  useEffect(() => {
    if (messageNeedSave) {
      message.open({
        content: <><p style={{ color: 'red', fontSize: '15px' }}>Modifications non prises en compte<br/>Pensez à enregistrer la trame à la fin des modifs</p><Button onClick={() => {
          message.destroy("message")
          saveTrame()
        }}>Enregistrer</Button></>,
        duration: 0,
        key: 'message'
      })
    } else {
      message.destroy("message")
    }
  }, [messageNeedSave])

  const html = '<html style="overflow: hidden"><header></header><body style="margin: 0"><iframe style="overflow: hidden" onclick="print();" height="100%" width="100%" src="' + (idPreview != undefined ? "https://staging.prosperences.fr/c/adhocreport/" + idPreview + "/html" : "") + '"></iframe></body></html>'

  return (
    <div style={{ display: 'flex' }}>
      <Button
        style={{ position: 'fixed', bottom: 20, right: '47.2%', height: '60px', width: '60px' }}
        type="primary"
        shape="circle"
        icon={<UpOutlined />}
        onClick={() => window.scrollTo(0, 0)}
      />
      <div style={{ width: '50%', padding: '20px' }}>
        <Button style={{ marginLeft: '10px' }} key="Fermer1" type='primary' shape='round' danger onClick={() => history.push(props.baseUrl + "/trames")}>
          Fermer
        </Button>
        <Button style={{ marginLeft: '10px' }} key="Enregister1" type='primary' shape='round' onClick={saveTrame}>
          Enregister
        </Button>
        <br />
        <Form layout="vertical">
          <Form.Item label="Adhoc V2">
            <Switch checked={trame.versionAdhoc == 2} onChange={(e) => {
              setTrame({ ...trame, versionAdhoc: e ? 2 : 1 })
            }} />
          </Form.Item>
          <Form.Item label="Nom de la trame">
            <Input
              placeholder="Trame 1"
              value={trame.name}
              onChange={(e) => setTrame({ ...trame, name: e.target.value })}
            />
          </Form.Item>
          {/* Logo prospérence  */}
          <Form.Item label="Insérer logo de Prospérences ?">
            <Switch checked={trame.prosperencesStyled} onChange={(e) => {
              setTrame({ ...trame, prosperencesStyled: e })
            }} />
          </Form.Item>
          <Form.Item label="Trame colorée ?">
            <Switch checked={trame.colored} onChange={(e) => {
              setTrame({ ...trame, colored: e })
            }} />
          </Form.Item>
          <Divider style={{ borderWidth: 5, borderColor: '#1990FF' }} />
          <Modules
            modules={trame.modules}
            onSave={(m: IModule[]) => {
              setTrame({
                ...trame, modules: JSON.parse(JSON.stringify(m))
              })
              setMessageNeedSave(true)
            }}
          />
        </Form>
        <br />
        <Button key="Fermer" type='primary' shape='round' danger onClick={() => history.push(props.baseUrl + "/trames")}>
          Fermer
        </Button>
        <Button style={{ marginLeft: '10px' }} key="Enregister" type='primary' shape='round' onClick={saveTrame}>
          Enregister
        </Button>
      </div>
      <div style={{ width: '50%', padding: '20px' }}>
        {/* <iframe width="100%" src={'data:text/html;charset=utf-8,' + encodeURI(html)} name='iframepdfhtml' id='iframepdfhtml'>
        </iframe> */}
        <Button onClick={() => {
          var proxyIframe = document.createElement('iframe');
          var body = document.getElementsByTagName('body')[0];
          body.appendChild(proxyIframe);
          proxyIframe.style.width = '100%';
          proxyIframe.style.height = '100%';
          proxyIframe.style.display = 'none';

          var contentWindow = proxyIframe.contentWindow;
          contentWindow?.document.open();
          // Set dimensions according to your needs.
          // You may need to calculate the dynamically after the content has loaded
          contentWindow?.document.write('<iframe src="' + "https://staging.prosperences.fr/c/adhocreport/7fcf786f-4652-40de-a891-a2056fbed1a8/html" + '" onload="print();" width="1000" height="1800" frameborder="0" marginheight="0" marginwidth="0">');
          contentWindow?.document.close();
        }} type='primary' shape='round'>pdf</Button>
        <br />
        <br />
        <iframe id='iframetopdf' src={'data:text/html;charset=utf-8,' + encodeURI(html)} name='iframepdfhtml' style={{ width: '100%', height: '10000px' }}></iframe>
      </div>
    </div>
  )
}
